module.exports = __webpack_public_path__ + "images/FUSA_icons/069-discount-1.5f0ca4c229f33f049856cad34105af37.svg";